<template>
	<div class="container">


		<div class="my-err">
			<div class="item">
				<label class="list-icon">&#xe614;</label>
			</div>
			<div class="item">
				<label class="list-text">{{msg}}</label>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				msg: ''
			}
		},
		created() {
			let d = this.$route.query;
			console.log('接受参数', d);
			this.msg = d.val;
		},
		methods: {

		}
	}
</script>

<style scoped>
	.container {
		width: 100%;
		max-width: 100%;
		overflow-x: hidden;

		font-size: 12px;
		line-height: 24px;
		background-color: #f0f0f0;
		display: flex;
		justify-content: center;
	}

	.my-err {
		display: flex;
		flex-direction: column;
		padding-top: 120px;
		height: 100vh
	}

	.item {
		display: flex;
		align-items: center;
		width: 100%;
		flex-direction: column;
	}


	.list-icon {
		display: inline-flex;
		width: 48px;
		height: 48px;
		line-height: 48px;
		font-size: 48px;
		color: #ff0000;
		text-align: center;
		font-weight: bolder;
		font-family: texticons;
		margin-right: 2px;
		vertical-align: middle;

		justify-content: center;
	}

	.list-text {
		display: inline-flex;
		margin-top: 80px;
		text-align: left;
		color: #000000;
		font-size: 18px;

	}
</style>
